import $ from 'jquery';
import _ from 'lodash';

import BasePropertyView from 'BasePropertyView.js';
import Immutable from 'immutable';
import contentTemplate from 'behaviors/properties/main/notify/edit-notification-email.ejs';
import propertyViewMapService from 'PropertyViewMapService.js';
import RestService from 'RestService';
import Constants from 'Constants.js'
import notificationService  from 'NotificationService.js';

class EditNotificationEmailView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#editNotificationEmail';
        this.factoryKey = opts.factoryKey;
        this.table = Constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;

        if (this.factoryKey === undefined) {
            this.factoryKey = this.model.attributes.factoryKey;
        }
        if (!this.model.get('emailDisplayName')) {
            this.model.set('emailDisplayName', '', {silent: true})
        }
        if (!this.model.get('emailEmailAddress')) {
            this.model.set('emailEmailAddress', '', {silent: true})
        }
        if (!this.model.get('emailReplyToDisplayName')) {
            this.model.set('emailReplyToDisplayName', '', {silent: true})
        }
        if (!this.model.get('emailReplyToEmailAddress')) {
            this.model.set('emailReplyToEmailAddress', '', {silent: true})
        }
        if (!this.model.get('emailAuthUsername')) {
            this.model.set('emailAuthUsername', '', {silent: true})
        }
        if (!this.model.get('emailAuthPassword')) {
            this.model.set('emailAuthPassword', '', {silent: true})
        }
        if (!this.model.get('emailServers')) {
            let emailServers = [ {
                'id': '',
                'name': 'Default',
                'isDefault': true}
            ];
            this.model.set('emailServers', emailServers, {silent: true});
            this.getEmailServers(emailServers);
        }

        this.events = {
            'change #emailServer'   : 'updateSelectAttributes',
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'  : 'getFocus'
        };

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set(propName, propVal)
        this.updateGrid(propName, propVal);
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.enableEmailServerOverrideSection(propVal, propName);

        this.model.set('emailServerId', propVal)
        this.updateGrid('emailServerId', propVal);
    }

    enableEmailServerOverrideSection(value, name){
        if(value.toLowerCase() !== "default" && value.toLowerCase() !== ""){
            $("#optionalOverridesSection").removeClass("disabledPanel");
           
            if(name === "emailServer"){
                const emailServer = this.model.get("emailServers").filter((server)=>{ return server.id === value});
    
                if(emailServer[0].AuthMethod !== "1"){
                    $("#emailEmailAddress").prop('disabled', true);
                    $("#emailAuthUsername").prop('disabled', true);
                    $("#emailAuthPassword").prop('disabled', true); 
                    
                    $("#emailEmailAddress").val('');
                    $("#emailAuthUsername").val('');
                    $("#emailAuthPassword").val('');       
                }
                else{
                    $("#emailEmailAddress").prop('disabled', false);
                    $("#emailAuthUsername").prop('disabled', false);
                    $("#emailAuthPassword").prop('disabled', false);                   
                }
            }
    
        }
        else{
            $("#emailEmailAddress").prop('disabled', false);
            $("#emailAuthUsername").prop('disabled', false);
            $("#emailAuthPassword").prop('disabled', false);         
            $("#optionalOverridesSection").addClass("disabledPanel");
        }
    }

    getEmailServers(emailServers) {
        let self = this;

        RestService.getEmailServers().then((RESULT)=> {
            $('#emailServers').empty();
            self.addOption(emailServers[0]);

            if (RESULT && RESULT !== null) {

                if ( Array.isArray(RESULT) )
                {
                    _.forEach(RESULT, function (emailServer) {
                        let serverItem = {
                            'id': _.get(emailServer, '@EmailServerId'),
                            'name': _.get(emailServer, '@Name'),
                            'isDefault': _.get(emailServer, '@isDefault').toUpperCase === "TRUE",
                            'AuthMethod': _.get(emailServer, '@AuthMethod')
                        };

                        emailServers.push(serverItem);
                        self.addOption(serverItem);

                    });
                } else {
                    let serverItem = {
                        'id': RESULT['@EmailServerId'],
                        'name': RESULT['@Name'],
                        'isDefault': RESULT['@isDefault'].toUpperCase === "TRUE"
                    };

                    emailServers.push(serverItem);
                    self.addOption(serverItem);
                }

            }
            self.model.set('emailServers', emailServers, {silent:true});

        }).catch((error)=> {
            console.log('The following error has ocurred', error)
        });
    }

    addOption(serverItem){
        $('#emailServers').append($('<option>', {
            value: serverItem.id,
            html: serverItem.name
        }));
    }

    updateGrid(field, value) {
        let id = $(this.table).getGridParam('selrow');
        let rowData = $(this.table).getRowData(id);
        rowData[field] = value;
        $(this.table).setRowData(id, rowData);
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        const emailServer = this.model.get('emailServerId');
        if(emailServer) {
            this.enableEmailServerOverrideSection(emailServer);
            //If current server does not exist on the email server list then we set it to empty/default
            let _optionToSelect = $('#emailServer').find(`option[value='${emailServer}']`);
            if (_optionToSelect.length === 0){
                this.model.set('emailServerId', '', {silent:true});
                this.updateGrid('emailServerId', '');
                $('#editNotificationEmailTab').trigger('click');
                notificationService.info('The configured Email Server for this notification does not exist. The default server will be used.');
            }else{
                _optionToSelect.attr('selected', true);
            }
        }

        return this;

    }
}

export default EditNotificationEmailView;
